export default __webpack_public_path__ + "static/media/GRE.6365b971.svg";